import './component.scss'
import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import 'PackWerkNurikaeSite/pages/companies/index/partials/subsidy_experience_card/component'

document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementById('subsidy_experience') !== null) {
    const splideSubsidyExperience = new Splide('.splide#subsidy_experience', {
      perPage: 1,
      perMove: 1,
      pagination: false,
    });
    splideSubsidyExperience.mount();
  }
});
